export const INACTIVE_CHECKOUT_CODES = [
  1003,
  1005,
  1006,
  1007,
  1012,
  1016,
  1017,
  1018,
];
